export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/rents/state.js